import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormChargeDetailsComponent } from '../../forms/charge-details/charge-details.component';
import { FormChargePriceComponent } from '../../forms/charge-price/charge-price.component';
import { FormChargeScheduleComponent } from '../../forms/charge-schedule/charge-schedule.component';
import { KeyName} from 'src/app/app.keynames';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from 'src/app/_core/services';
import { BillCycleTypeValues, ChargeType, RatePlanType } from 'src/app/app.data';
import { FormChargeRulesComponent } from '../../forms/charge-rules/charge-rules.component';

@Component({
  selector: 'dialog-new-charge',
  templateUrl: './dialog-new-charge.component.html',
  styles: [`
    .required-fields {
      color: red !important
    }
  `
  ],
})
export class DialogNewChargeComponent implements OnInit {

  @ViewChild(FormChargeDetailsComponent) _formChargeDetailsComponent: FormChargeDetailsComponent;
  @ViewChild(FormChargePriceComponent) _formChargePriceComponent: FormChargePriceComponent;
  @ViewChild(FormChargeScheduleComponent) _formChargeScheduleComponent: FormChargeScheduleComponent;

  chargeDetailsFormErrors: boolean = false;
  chargePriceFormErrors: boolean = false;
  chargeScheduleFormErrors: boolean = false;
  ratePlanCharge: any = {};
  ratePlanTypeSelected: string = null;
  selectedChargeType: ChargeType = ChargeType.oneTimeCharge;
  selectedBillCycleTypeValue: BillCycleTypeValues = BillCycleTypeValues.subscriptionStartDay;

  @Input() _ratePlanType = RatePlanType;

  @ViewChild(FormChargeRulesComponent) _formChargeRulesComponent: FormChargeRulesComponent;
  chargeRulesFormErrors: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogNewChargeComponent>,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _loader: LoaderService,
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  ngOnInit(): void {
    this.ratePlanTypeSelected = this.data.ratePlanTypeSelected;

    this.handlePercentAmountInit();
  }

  onClose(): void {
    this._dialogRef.close();
  }

  appendDataToObject(obj, data) {
    const object = { ...obj };
    return {
      ...object,
      ...data,
    };
  }

  onGetChargeType(_chargeType: ChargeType){
    this.selectedChargeType = _chargeType;
  }

  onGetBillCycleType(_billCycleTypeValues: BillCycleTypeValues){
    this.selectedBillCycleTypeValue = _billCycleTypeValues;
  }

  onGetChargeDetailsBodyParams(_bodyParams: any) {
    this.chargeDetailsFormErrors = false;
    this.ratePlanCharge = this.appendDataToObject(this.ratePlanCharge, _bodyParams);
  }

  onGetChargePriceBodyParams(_bodyParams: any) {
    this.chargePriceFormErrors = false;
    this.ratePlanCharge = this.appendDataToObject(this.ratePlanCharge, _bodyParams);
  }

  onGetChargeScheduleBodyParams(_bodyParams: any) {
    this.chargeScheduleFormErrors = false;
    this.ratePlanCharge = this.appendDataToObject(this.ratePlanCharge, _bodyParams);
  }

  onGetChargeDetailsFormErrors(anyError: boolean) {
    this.chargeDetailsFormErrors = anyError;
  }

  onGetChargePriceFormErrors(anyError: boolean) {
    this.chargePriceFormErrors = anyError;
  }

  onGetChargeScheduleFormErrors(anyError: boolean) {
    this.chargeScheduleFormErrors = anyError;
  }

  onSubmit(): void {
    this._formChargeDetailsComponent.setBodyParams();
    this._formChargePriceComponent.setBodyParams();
    this._formChargeScheduleComponent.setBodyParams();
    this._formChargeRulesComponent.setBodyParams();

    if (!this.chargeDetailsFormErrors && !this.chargePriceFormErrors && !this.chargeScheduleFormErrors  && !this.chargeRulesFormErrors) {
      this.overideBody();
      this._loader.startPageLoader();
      this._dialogRef.close({ code: KeyName.change_charge, bodyParams: this.ratePlanCharge, isEdit: this.data.isEdit});
    }
  }

  overideBody() {
    if(this.ratePlanCharge.usageType && !this.data.isProduct && !this.data.isEdit) {
      this.ratePlanCharge.quantity = 0;
    }

    if(this.ratePlanCharge.priceType === 'percent') {
      if(!this.data.isProduct) {
        this.ratePlanCharge.price = this.ratePlanCharge.price / 100;  // show the price multiplied by 100 and store it divided by it
      } else {
        this.data.chargeTier = this.data.chargeTier?.map(item => item.price / 100);
      }
    }
  }

  handlePercentAmountInit(){
    if(this.data.priceType === 'percent') {
      if(!this.data.isProduct) {
        this.data.price = this.data.price * 100; // show the price multiplied by 100 and store it divided by it
      } else {
        this.data.chargeTier = this.data.chargeTier?.map(item => item.price * 100);
      }
    }
  }
  
  onGetChargeRules(_bodyParams: any) {
    this.chargeRulesFormErrors = false;
    this.ratePlanCharge = this.appendDataToObject(this.ratePlanCharge, _bodyParams);
  }

  onGetChargeRulesFormErrors(anyError: boolean) {
    this.chargeRulesFormErrors = anyError;
  }
}
